import module from "./user-component.js";
export default module;



// WEBPACK FOOTER //
// ./src/ui/modules/dcb-eaccount/directives/user-component/index.js